import { render, staticRenderFns } from "./realtimeVideo.vue?vue&type=template&id=bbb98c24&scoped=true"
import script from "./realtimeVideo.vue?vue&type=script&lang=js"
export * from "./realtimeVideo.vue?vue&type=script&lang=js"
import style0 from "./realtimeVideo.vue?vue&type=style&index=0&id=bbb98c24&prod&lang=scss&scoped=true"
import style1 from "./realtimeVideo.vue?vue&type=style&index=1&id=bbb98c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb98c24",
  null
  
)

export default component.exports